<div class="hd-dialog">

  <!-- Header -->
  <div class="hd-header">
    <div class="hd-title-wrap">
      <div class="hd-title-icon">
        <mat-icon>delete_outline</mat-icon>
      </div>
      <div class="hd-title-text">
        <h2 class="hd-title">{{dialogTitle}}</h2>
        <div class="hd-subtitle">Select what to remove — this can't be undone</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="hd-close" [disabled]="deleting" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <form id="harvestGroupDelete" class="hd-body" [class.single]="hideHarvests || hideGroups" (ngSubmit)="deleteClick()">

    <!-- Harvests -->
    @if (!hideHarvests) {
      <section class="hd-col">
        <div class="hd-col-head">
          <span class="hd-col-title">
            <mat-icon>local_florist</mat-icon> Harvests
          </span>
          <span class="hd-count" [class.on]="harvests.length > 0">{{harvests.length}} selected</span>
        </div>

        <app-harvest-select-multi-btn
          class="hd-picker"
          [showUpcomingHarvests]="false"
          [appStorageNeeded]="false"
          [startWithNoneSelected]="true"
          [(selectedHarvests)]="harvests">
        </app-harvest-select-multi-btn>

        <div class="hd-list">
          @if (harvests.length === 0) {
            <div class="hd-empty">
              <mat-icon>inbox</mat-icon>
              No harvests selected
            </div>
          } @else {
            @for (harvest of harvests; track harvest) {
              <div class="hd-row">
                <span class="hd-dot" [style.background]="harvest.color || '#c9d2cc'"></span>
                <span class="hd-row-name">{{harvest.displayValue}}</span>
              </div>
            }
          }
        </div>
      </section>
    }

    <!-- Task Groups -->
    @if (!hideGroups) {
      <section class="hd-col">
        <div class="hd-col-head">
          <span class="hd-col-title">
            <mat-icon>workspaces</mat-icon> Task groups
          </span>
          <span class="hd-count" [class.on]="groups.length > 0">{{groups.length}} selected</span>
        </div>

        <app-task-group-select-multi-btn
          class="hd-picker"
          [showUpcomingHarvests]="true"
          [appStorageNeeded]="false"
          [startWithNoneSelected]="true"
          [(selectedGroups)]="groups">
        </app-task-group-select-multi-btn>

        <div class="hd-list">
          @if (groups.length === 0) {
            <div class="hd-empty">
              <mat-icon>inbox</mat-icon>
              No task groups selected
            </div>
          } @else {
            @for (group of groups; track group) {
              <div class="hd-row">
                <span class="hd-dot" [style.background]="group.color || '#c9d2cc'"></span>
                <span class="hd-row-name">{{group.displayValue}}</span>
              </div>
            }
          }
        </div>
      </section>
    }
  </form>

  <!-- Footer -->
  <div class="hd-footer">
    <span class="hd-footer-note">
      <mat-icon>warning_amber</mat-icon>
      @if (totalSelected > 0) {
        {{totalSelected}} item{{totalSelected === 1 ? '' : 's'}} will be permanently deleted.
      } @else {
        Deleting is permanent and can't be undone.
      }
    </span>
    <div class="hd-footer-actions">
      <button mat-button mat-dialog-close class="hd-btn-ghost" [disabled]="deleting">Cancel</button>
      <button type="submit" form="harvestGroupDelete" class="hd-btn-danger" [disabled]="deleting || totalSelected === 0">
        @if (deleting) {
          <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
        } @else {
          <mat-icon>delete</mat-icon>
          <span>Delete{{totalSelected > 0 ? ' ' + totalSelected : ''}}</span>
        }
      </button>
    </div>
  </div>
</div>
